import angular from 'angular';

import './bd-toolbar.styles.scss';

const BackdropToolbarTemplate = /* html */ `
<div class="backdrop-toolbar" ng-init="expanded = false;">
  <div class="toolbar-background" ng-if="expanded"></div>

  <button type="button" class="btn-fab expand-button" ng-click="expanded = !expanded">
    <svg class="ab-icon" ng-show="!expanded"><use xlink:href="#btn-edit"></use></svg>
    <svg class="ab-icon" ng-show="expanded"><use xlink:href="#btn-times"></use></svg>
  </button>

  <div class="btn-wrap right" ng-transclude ng-class="{'expanded': expanded}"></div>
</div>
`;

export const BackdropToolbarComponent = {
  selector: 'bdToolbar',
  transclude: true,
  template: BackdropToolbarTemplate,
};

export default angular.module('autoboard.bdToolbar', [])
  .component(BackdropToolbarComponent.selector, BackdropToolbarComponent)
  .name;
